import { render, staticRenderFns } from "./AdminCampaignOverview.vue?vue&type=template&id=437fa5fe&"
import script from "./AdminCampaignOverview.vue?vue&type=script&lang=ts&"
export * from "./AdminCampaignOverview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports